var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sendMessage" },
    [
      _vm._l(_vm.messages, function (item, key) {
        return _c(
          "div",
          {
            key: item.id,
            class: {
              user: _vm.isType("user", item),
              agent: _vm.isType("agent", item),
              url: _vm.isType("url", item),
              system: _vm.isType("system", item),
              "user-share-cart": _vm.isType("user_share_cart", item),
              call: _vm.isType("call", item),
              image: _vm.isType("image", item),
              file: _vm.isType(item),
              virus_detected: _vm.isType("virus_detected", item),
            },
          },
          [
            _vm.showAuthorName(key)
              ? _c(
                  "div",
                  {
                    staticClass: "message-author",
                    class: {
                      "message-user": _vm.isType("user", item),
                      "message-agent": _vm.isType("agent", item),
                    },
                  },
                  [
                    _vm.isType("agent", item)
                      ? _c(
                          "p",
                          {
                            staticClass: "author-name",
                            attrs: { tabindex: "0", "aria-live": "assertive" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.agent.name) +
                                " " +
                                _vm._s(_vm.formatTimestamp(item.created_at))
                            ),
                          ]
                        )
                      : _vm.isType("user", item)
                      ? _c(
                          "p",
                          {
                            staticClass: "author-name",
                            attrs: { tabindex: "0", "aria-live": "assertive" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.user.name
                                    ? _vm.user.name
                                    : _vm.$gettext("Yo")
                                ) +
                                " " +
                                _vm._s(_vm.formatTimestamp(item.created_at))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            item.text == "showVideoChatCallbutton()"
              ? _c("div")
              : _vm.isType("user_share_cart", item)
              ? _c(
                  "div",
                  {
                    staticClass: "message-wrapper d-flex",
                    attrs: { tabindex: "0", "aria-live": "assertive" },
                  },
                  [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("div", { staticClass: "cart-icon" }),
                      _c("span", {
                        staticClass: "text",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$gettext(
                              "Su carrito de compra ha sido compartido con el agente."
                            )
                          ),
                        },
                      }),
                    ]),
                  ]
                )
              : _vm.isType("call", item)
              ? _c(
                  "div",
                  {
                    staticClass: "acceptVideoConditions",
                    attrs: { tabindex: "0", "aria-live": "assertive" },
                  },
                  [
                    _c("div", { staticClass: "header-text" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$gettext(
                              "Has solicitado el servicio de videoasistencia."
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "start-call" }, [
                      _vm._v(
                        " " + _vm._s(_vm.formatTimestamp(item.created_at))
                      ),
                    ]),
                    _c("div", { staticClass: "startedCall" }, [
                      _c("div", { staticClass: "cam-icon" }),
                      _c("div", { staticClass: "text-video" }, [
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$gettext("Videoasistencia finalizada"))
                            ),
                          ]),
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.getDuration(item)))]),
                      ]),
                    ]),
                    _c("br"),
                  ]
                )
              : _vm.isType("system", item)
              ? _c(
                  "div",
                  {
                    staticClass: "message-wrapper d-flex",
                    attrs: { tabindex: "0", "aria-live": "assertive" },
                  },
                  [
                    _c("div", { staticClass: "info-icon" }),
                    _c("p", {
                      staticClass: "text",
                      domProps: { innerHTML: _vm._s(item.text) },
                    }),
                  ]
                )
              : _vm.isType("image", item)
              ? _c(
                  "div",
                  {
                    staticClass: "message-wrapper message-wrapper--img d-flex",
                    class: { "message-user": item.agent_id == 0 },
                    attrs: { tabindex: "0", "aria-live": "assertive" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "thumbnail",
                        on: {
                          click: function ($event) {
                            return _vm.downloadImage(
                              item.file_href,
                              item.file_name
                            )
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "image-container" }, [
                          _vm.getDocumentType(item?.file_name) == "image"
                            ? _c("img", {
                                attrs: {
                                  src: _vm.baseUrl + item?.file_name,
                                  alt: "image",
                                },
                                on: { error: _vm.setAltImg },
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("@/assets/images/file-icon.svg"),
                                  alt: "File",
                                },
                              }),
                        ]),
                        _c("p", { staticClass: "img__details" }, [
                          _vm._v(_vm._s(item.file_name)),
                        ]),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.agent_id == 0,
                            expression: "item.agent_id == 0",
                          },
                        ],
                        staticClass: "delete-basket",
                        attrs: { name: "deleteImage" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteImage(item.message_id)
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/delete-icon.svg"),
                            alt: "Delete Image",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm.isType("url", item)
              ? _c(
                  "div",
                  {
                    staticClass: "message-wrapper message-wrapper--url d-flex",
                    attrs: { tabindex: "0", "aria-live": "assertive" },
                  },
                  [
                    _c("div", { staticClass: "url" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: item.text,
                            target: _vm.isExternalLink(item.text)
                              ? "_blank"
                              : "_self",
                          },
                          on: { click: _vm.handleLinkClicked },
                        },
                        [
                          _vm._m(0, true),
                          _vm._v(" " + _vm._s(_vm.filterUrl(item.text)) + " "),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm.isType("virus_detected", item)
              ? _c(
                  "div",
                  {
                    staticClass: "message-wrapper d-flex",
                    class: {
                      lastUser: key === _vm.lastMessageOfType.user,
                      lastAgent: key === _vm.lastMessageOfType.agent,
                    },
                    attrs: { "aria-live": "assertive", tabindex: "0" },
                  },
                  [
                    _c("div", { staticClass: "virus" }, [
                      _c("div", { staticClass: "text virus-content" }, [
                        _vm._m(1, true),
                        _c("div", { staticClass: "virus-text" }, [
                          _c("span", { staticClass: "virus-bold" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$gettext(
                                  "No se han podido enviar los archivos"
                                )
                              )
                            ),
                          ]),
                          _c("br"),
                          _c("br"),
                          _c("span", { staticClass: "virus-subtitle" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$gettext("Hemos detectado código malicioso")
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "contact" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$gettext(
                                "Por favor, vuelve a intentarlo o ponte en contacto con"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "contact-link",
                            attrs: {
                              href: "https://www.google.com",
                              target: "_blank",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$gettext("atención al cliente")))]
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm.isType("call", item)
              ? _c(
                  "div",
                  {
                    staticClass: "acceptVideoConditions",
                    attrs: { tabindex: "0", "aria-live": "assertive" },
                  },
                  [
                    _c("div", { staticClass: "header-text" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$gettext(
                              "Has solicitado el servicio de videoasistencia."
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "startedCall" }, [
                      _c("div", { staticClass: "cam-icon" }),
                      _c("div", { staticClass: "text-video" }, [
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$gettext("Videoasistencia iniciada"))
                            ),
                          ]),
                        ]),
                        _c("p"),
                      ]),
                    ]),
                    _c("br"),
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass: "message-wrapper d-flex",
                    class: {
                      lastUser: key === _vm.lastMessageOfType.user,
                      lastAgent: key === _vm.lastMessageOfType.agent,
                    },
                    style: _vm.getTextStyle(item),
                    attrs: { tabindex: "0", "aria-live": "assertive" },
                  },
                  [
                    _c("p", {
                      staticClass: "text",
                      domProps: {
                        innerHTML: _vm._s(_vm.convertUnicodeToEmoji(item.text)),
                      },
                    }),
                  ]
                ),
          ]
        )
      }),
      this.call
        ? _c(
            "div",
            {
              staticClass: "acceptVideoConditions",
              attrs: { "aria-live": "assertive", tabindex: "0" },
            },
            [
              _c("div", { staticClass: "header-text" }, [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$gettext(
                        "Has solicitado el servicio de videoasistencia."
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "start-call" }),
              _c("div", { staticClass: "startedCall" }, [
                _c("div", { staticClass: "cam-icon" }),
                _c("div", { staticClass: "text-video" }, [
                  _c("p", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$gettext("Videollamada iniciada"))),
                    ]),
                  ]),
                  this.activeVideocall
                    ? _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.getElapsedTime(this.activeVideocall.dtcreated)
                          )
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _c("br"),
            ]
          )
        : _vm._e(),
      !_vm.chatRated && _vm.threadState == "closed"
        ? _c(
            "div",
            {
              staticStyle: { "margin-top": "20px" },
              attrs: { tabindex: "0", "aria-live": "assertive" },
            },
            [
              _c("div", { staticClass: "endConversationMessage" }, [
                _c("i", {
                  staticClass: "success-color icon-message-confirmation",
                }),
                _vm._v(
                  " " +
                    _vm._s(
                      this.chatRated
                        ? _vm.$gettext("Gracias por tu opinión")
                        : this.closeByInactivity
                        ? _vm.$gettext("Conversación finalizada")
                        : _vm.$gettext("Conversación finalizada exitosamente")
                    ) +
                    " "
                ),
              ]),
              _c("satisfaction-poll"),
            ],
            1
          )
        : _vm._e(),
      _vm.threadState != "closed" && this.callForm && !this.isBanned
        ? _c("div", { staticClass: "acceptVideoConditions" }, [
            _c(
              "div",
              {
                staticClass: "header-text",
                attrs: { tabindex: "0", "aria-live": "assertive" },
              },
              [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$gettext(
                        "Has solicitado el servicio de videoasistencia."
                      )
                    )
                  ),
                ]),
                this.call
                  ? _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$gettext("Esperando a que el agente responda")
                        )
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            !this.call
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "video-condition-container",
                      attrs: { tabindex: "0" },
                    },
                    [
                      _c("div", { staticClass: "video-msg" }, [
                        _c("div", { staticClass: "cam-icon" }),
                        _c("div", { staticClass: "text-video" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.$gettext(
                                  "Tu agente te atenderá mediante llamada."
                                )
                              )
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$gettext(
                                  "Te guiará a través de la web para ayudarte de forma más rápida y sencilla."
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _c("p", { staticClass: "text-conditions" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$gettext(
                              "No se activará tu cámara en ningún momento. Solo el agente compartirá su imagen y pantalla para que puedas seguir los pasos cómodamente."
                            )
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "conditions" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$gettext(
                                'Al hacer clic en "Iniciar Videollamada", confirmo que he leído y acepto la '
                              )
                            ) + " "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.policy_url,
                                target: "_blank",
                                rel: "noopener",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("Política de datos")))]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c("div", { attrs: { id: "call-buttons-container" } }, [
                    _c(
                      "button",
                      {
                        staticClass: "cancel",
                        attrs: { tabindex: "0", name: "cancelCall" },
                        on: { click: _vm.cancelCall },
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Cancelar")))]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "startCall",
                        attrs: { tabindex: "0", name: "startCall" },
                        on: { click: _vm.showSelectDevices },
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Iniciar Videollamada")))]
                    ),
                  ]),
                ])
              : _vm._e(),
            _c("br"),
          ])
        : _vm._e(),
      _vm.selectDevices && !this.isBanned
        ? _c("DeviceSelector", { on: { closeModal: _vm.closeModal } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "url-icon" }, [
      _c("img", {
        staticClass: "link-icon",
        attrs: {
          src: require("../../src/assets/images/link.svg"),
          alt: "link",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        staticClass: "virus-icon",
        attrs: {
          src: require("../../src/assets/images/incorrect.svg"),
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }